"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDropdownSharedPropsContext = useDropdownSharedPropsContext;

var _react = require("react");

var _DropdownSharedPropsContext = _interopRequireDefault(require("./DropdownSharedPropsContext"));

function useDropdownSharedPropsContext() {
  return (0, _react.useContext)(_DropdownSharedPropsContext.default);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1c2VEcm9wZG93blNoYXJlZFByb3BzQ29udGV4dCIsInVzZUNvbnRleHQiLCJEcm9wZG93blNoYXJlZFByb3BzQ29udGV4dCJdLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0Ryb3Bkb3duL0Ryb3Bkb3duU2hhcmVkUHJvcHNDb250ZXh0L0Ryb3Bkb3duU2hhcmVkUHJvcHNDb250ZXh0Lmhvb2tzLnRzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IHVzZUNvbnRleHQgfSBmcm9tICdyZWFjdCdcbmltcG9ydCBEcm9wZG93blNoYXJlZFByb3BzQ29udGV4dCBmcm9tICcuL0Ryb3Bkb3duU2hhcmVkUHJvcHNDb250ZXh0J1xuXG5leHBvcnQgZnVuY3Rpb24gdXNlRHJvcGRvd25TaGFyZWRQcm9wc0NvbnRleHQoKSB7XG4gIHJldHVybiB1c2VDb250ZXh0KERyb3Bkb3duU2hhcmVkUHJvcHNDb250ZXh0KVxufVxuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQTs7QUFDQTs7QUFFTyxTQUFTQSw2QkFBVCxHQUF5QztFQUM5QyxPQUFPLElBQUFDLGlCQUFBLEVBQVdDLG1DQUFYLENBQVA7QUFDRCJ9